import { deleteAjcoperationsadmindeliveryschedulebyzipcode } from '../../../graphql/mutations';
import { gql, useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { GET_DELIVERY_ZIP_CODE } from '../../queries/useGetDeliveryZipCode';

export const useDeleteDeliveryZip = () => {
  const DELETE_DELIVERY_ZIP = gql`
    ${deleteAjcoperationsadmindeliveryschedulebyzipcode}
  `;

  const [
    deleteDeliverySchedule,
    {
      error: deleteDeliveryError,
      data: deleteDeliveryData,
      loading: deleteDeliveryLoading,
    },
  ] = useMutation(DELETE_DELIVERY_ZIP, {
    refetchQueries: [
      {
        query: GET_DELIVERY_ZIP_CODE,
        variables: { limit: 10000 },
      },
    ],
    awaitRefetchQueries: true,
    onCompleted: () => {
      toast.success('Deleted Successfully');
    },
    onError: (error) => {
      toast.error('Something went wrong');
    },
  });

  return {
    deleteDeliverySchedule,
    deleteDeliveryError,
    deleteDeliveryData,
    deleteDeliveryLoading,
  };
};
